// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"261":"39fb015d","336":"1d28da70","340":"0e546c89","586":"8f644d0a","828":"74209645","973":"2b55e7ec"}[chunkId] + ".chunk.css";
};